import React from "react";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useDesktopHeaderHeight } from "arena/components/AppShell/AppModeContext";

// Ультра-легковесный компонент placeholder для виртуализации
export default function ShortyPlaceholder() {
  const theme = useTheme();
  const isMobileView = useMediaQuery(theme.breakpoints.down("md"));
  const headerHeight = useDesktopHeaderHeight();

  return (
    <Box
      sx={{
        width: "100%",
        height: isMobileView
          ? "100dvh" // Dynamic viewport height для мобильных
          : `calc(100vh - ${headerHeight}px)`, // На десктопе обычный vh минус header
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        scrollSnapAlign: "start",
        scrollSnapStop: "always",
        flexShrink: 0, // Предотвращаем сжатие элемента
        position: "relative",
        // Убираем margin для точной навигации в полноэкранном режиме
      }}
    >
      {isMobileView ? (
        // Полноэкранный placeholder для мобилки
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "#0a0a0a",
            border: "1px solid #1a1a1a",
          }}
        />
      ) : (
        // Placeholder с aspect-ratio для десктопа (аналогично ShortyVideoContent)
        <Box
          sx={{
            width: "auto",
            height: "100%",
            aspectRatio: "9/16", // Соотношение сторон 9:16
            maxWidth: "100%",
            backgroundColor: "#0a0a0a",
            border: "1px solid #1a1a1a",
          }}
        />
      )}
    </Box>
  );
}
